import { render, staticRenderFns } from "./PlaybooksList.vue?vue&type=template&id=e5a84d58&scoped=true&"
import script from "./PlaybooksList.vue?vue&type=script&lang=js&"
export * from "./PlaybooksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a84d58",
  null
  
)

export default component.exports